<template>
  <div class="createNewStory">
    <v-container class=" fill-height mt-5 pt-5 pr-0 mb-0 pb-0">
        <v-row class="mt-2 pt-0 mb-0 pb-0 px-2 secondaryVariant" >

          <v-col align="right" col=3>
        <createNewStoryPreview />
          </v-col>
      </v-row>
      <v-row style="height: 8vh;z-index: 2;" class="pt-5 pb-5 mb-5 px-2">
        <v-col v-if="isEditTitle==false" cols="10" class="mt-0 pt-0 pb-2">
          <h4>{{$t('storyTitle')}}</h4>
          <span>{{cache.storyTitle}}</span>
        </v-col>
        <v-col v-else cols="10" class="mt-0 pt-0 pb-2">
          <h4 mb-5>{{$t('storyTitle')}}</h4>
          <v-text-field :rules="[v => (v || '' ).length >= 4 || $t('TitleRule')]" class="mt-0 pt-0 pb-2"
            v-model="cache.storyTitle" hide-details="auto">
          </v-text-field>
        </v-col>
        <v-col cols="2">
          <v-btn icon color="primaryVariant" @click="toggleEditTitle()">
            <v-icon v-if="isEditTitle!=false"> mdi-pencil</v-icon>
            <v-icon v-else>mdi-pencil-lock</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="px-2">
        <v-col cols="12" align="left" class="mt-0 pt-0 mb-0 pb-0">
          <span class="font-weight-bold">{{$t('location')}}</span>
        </v-col>
        <v-col col=10>
          <createNewStoryAddLocationContent />
        </v-col>
                <v-col col=2>
        </v-col>
      </v-row>
      <v-row class="px-2" >
        <v-col cols="10">
          <v-autocomplete :items="tags" item-text="tag" item-value="id" :label="$t('addedKeyword')" multiple chips clerable
            deletable-chips ref="tagList" v-model="selectedTags">
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-row class="px-2">
        <v-col cols="12">
          <template
            v-if="(cache.storyTitle==''||!cache.hasOwnProperty('storyTitle'))||(!tempMediaOnIndexDB.imageObj)||(cache.checkboxPublic&&tempMediaOnIndexDB.imageTitle=='')||cache.checkboxPublic&&cache.content==[]||!cache.hasOwnProperty('content')||(cache.marker.lat==null||cache.marker.lng==null||!cache.hasOwnProperty('marker'))">
            <span v-if="cache.checkboxPublic">{{$t("toPublishAreRequired")}}</span>
            <span v-if="!cache.checkboxPublic">{{$t("toSaveDraftAreRequired")}}</span>
          </template>
          <ul>
            <li v-if="cache.storyTitle==''||!cache.hasOwnProperty('storyTitle')">
              {{$t("title")}}
            </li>
            <li v-if="!tempMediaOnIndexDB.imageObj">
              {{$t("coverImage")}}
            </li>
            <li v-if="cache.checkboxPublic&&cache.content==[]||!cache.hasOwnProperty('content')">
              {{$t("content")}}
            </li>
            <li v-if="cache.marker.lat==null||cache.marker.lng==null||!cache.hasOwnProperty('marker')">
              {{$t("position")}}
            </li>
          </ul>
        </v-col>
      </v-row>

    </v-container>
      <v-footer color="white" :min-height="50" :fixed="true" :app="true"
        class="maxwidth mt-0 pt-0 mb-0 pb-0">
      <v-row v-if="typeof cache.tags !='undefined' && cache.tags.length>0" justify="end" class="px-2">
        <v-col cols="6">
          <v-btn class="clerablebutton" @click="resetTags">{{$t("clearAll")}}</v-btn>
        </v-col>
      </v-row>
      <v-row v-else align="end" class="px-2" >
        <v-col class="text-left mx-5 px-0" cols=10>{{$t("pleaseAddYourStoryKeyword")}}
        </v-col>
      </v-row>
        <v-container fill-height fluid class="mt-0 pt-0 mb-0 pb-0">
          <v-row>
          <v-col class="mt-0 pt-0 mb-0 pb-0 text-center" cols=12>
            <btnDraftOrPublish />
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
import createNewStoryAddLocationContent from "@/components/createOrEditStory/addLocationContent.vue"
import createNewStoryPreview from "@/components/createOrEditStory/preview";
import btnDraftOrPublish from "@/components/btnDraftOrPublish.vue"

  export default {
    name: "createNewStoryPublish",
    data: () => ({
      isEditTitle:false,
      apiUrl: process.env.VUE_APP_ROOT_API,
      tags: [],
      selectedTags:[]
    }),
    components: {
      createNewStoryPreview,
      btnDraftOrPublish,
      createNewStoryAddLocationContent
      },
    computed: {
    isEditTitleAndMapStory: {
      get: function () {
        return this.$store.getters.getIsEditTitleAndMapStory
      }
    },
    isLoading: {
      get: function () {
        return this.$store.getters.getLoading
      }
    },
      //all mediafile
      tempMediaOnIndexDB: {
        get: function() {
          return this.$store.state.tempMediaOnIndexDB
        },
        set: function(newValue) {
          this.$store.dispatch("setTempMediaOnIndexDB", newValue)
        }
      },
//info about the creating/editing story - position, title, content, tags, is_Published.
      cache: {
      get: function() {
        return this.$store.state.newStories
      },
      set: function (newValue) {
        this.$store.dispatch("setNewStories", newValue)
      }
    },
      getUser: function (){
        return this.$store.getters.getUser
      },
      areMissingRequirementToPublishOrSaveDraft: function () {
        //cache.storyTitle==''||!cache.hasOwnProperty('storyTitle')||tempMediaOnIndexDB.imageTitle==''">{{$t("toPublishAreRequired")||cache.marker.lat==null||cache.marker.lng==null||!cache.hasOwnProperty('marker')||cache.content==''||!cache.hasOwnProperty('content')
        return (this.cache.storyTitle == '' || this.tempMediaOnIndexDB.imageTitle=='' || this.cache.marker.lat == null || this.cache.marker.lng == null )
      }
    },
    watch: {
      '$store.state.newStories.storyTitle': function () {
        this.cache = this.$store.state.newStories
      },
      'selectedTags': function () {
        this.$store.dispatch("setNewStoriesTags", this.selectedTags)
                this.$refs.tagList.lazySearch = ""

      }
    },
    mounted: async function () {
      this.$store.dispatch("setIsEditTitleAndMapStory", false)
      await this.retriveListOfTags();
      this.cache = this.$store.getters.getNewStories

      if(typeof this.cache.tags =="undefined"){
        this.$refs.tagList.internalValue =[]
      }else{
        this.$refs.tagList.internalValue = this.cache.tags        
      }

    },
    methods: {
      closeTagMenu:function(){
        this.$refs.tagList.isMenuActive = false
      },
      resetTags:function () {
    this.selectedTags=[]
      },
    toggleEditTitle: function () {
      this.isEditTitle = !this.isEditTitle
      this.$store.dispatch("setIsEditTitleAndMapStory", this.isEditTitle)
      },

      //navigate to the web app page
      goBack: function () {
        this.saveCurrentStory().then(function(){
          this.$router.push('createNewStoryContent')
        }.bind(this))

      },
      //save preference in vuex
      saveCurrentStory:async function () {
        return this.$store.dispatch("setNewStories", {...this.cache})
      },
      //retrive the list of all aviable tags fram db
      async retriveListOfTags() {
        try {
          this.$store.dispatch('setLoading', true)
          let completeurl = this.apiUrl + '/getTags'
          let tagsFromDB
          tagsFromDB = await this.getaxiosResponse(completeurl)
          this.tags = tagsFromDB.data
          this.tags.forEach(item => item.tag = this.$i18n.t(item.tag))
          this.$store.dispatch('setLoading', false)
        } catch (error) {
          console.log(error);
        }
      }

    }
  }
</script>

<style>
.clerablebutton{
    border: 2px solid #000000;
    border-radius: 999rem;
    padding: 10px;
}
</style>